<template>
  <div class="listContainer">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb" @keyup.enter="onSearch">
      <span slot="separator">></span>
      <a-breadcrumb-item>运营数据</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a>员工战报</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section>
      <section class="searchBox">
        <span>
          <label>项目：</label>
          <a-select
            style="min-width:160px"
            v-model="project_id"
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option
              v-for="element in proList"
              :key="element.id"
              :value="element.id"
              >{{ element.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>日期：</label>
          <a-range-picker
            @change="selectedDate"
            v-model="dateDefault"
            style="width:200px"
          />
        </span>
        <span>
          <label>字符串：</label>
          <a>
            <a-input
              v-model="query_field"
              placeholder="请输入姓名 | 手机号码"
            />
          </a>
        </span>
        <span>
          <a-button style="margin-right:10px" @click="onDownload">
            <a-icon type="vertical-align-bottom" />下载
          </a-button>
          <a-button style="margin-right:10px" @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.user_name }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.project_name }}</td>
              <td>{{ item.count_order }}</td>
              <td>
                <span v-show="Number(item.total_reward_guard) != 0">{{
                  "奖励：" + Number(item.total_reward_guard) + "元&nbsp;&nbsp;"
                }}</span>
                <span v-show="Number(item.total_punish_guard) != 0">{{
                  "惩罚：" + Number(item.total_punish_guard) + "元"
                }}</span>
                <span
                  v-show="
                    Number(item.total_reward_guard) == 0 &&
                      Number(item.total_punish_guard) == 0
                  "
                  >—</span
                >
              </td>
              <td>{{ Number(item.total_checked_guard) + "元" }}</td>
              <td>
                <span v-show="Number(item.total_reward_three) != 0">{{
                  "奖励：" + Number(item.total_reward_three) + "元&nbsp;&nbsp;"
                }}</span>
                <span v-show="Number(item.total_punish_three) != 0">{{
                  "惩罚：" + Number(item.total_punish_three) + "元"
                }}</span>
                <span
                  v-show="
                    Number(item.total_reward_three) == 0 &&
                      Number(item.total_punish_three) == 0
                  "
                  >—</span
                >
              </td>
              <td>{{ Number(item.total_checked_three) + "元" }}</td>
              <td>{{ Number(item.profit) + "元" }}</td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      hideInAddShow: false,
      query_field: "",
      totalPage: Number,
      thList: [
        "员工姓名",
        "手机号码",
        "所属项目",
        "工单数量",
        "员工奖惩",
        "员工结算",
        "甲方奖惩",
        "甲方结算",
        "利润"
      ],
      start_date: "",
      end_date: "",
      project_id: "",
      proList: [],
      dateDefault: null
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro(); //项目
  },
  methods: {
    onDownload() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.clean +
        "Guard/guardCountDownload?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&project_id=" +
        this.project_id +
        "&query_field=" +
        this.query_field +
        "&start_date=" +
        this.start_date +
        "&end_date=" +
        this.end_date;
    },
    onReset() {
      this.query_field = "";
      this.start_date = "";
      this.end_date = "";
      this.project_id = "";
      this.dateDefault = undefined;
      this.page = 1;
      this.getData();
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 3
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    selectedDate(data, dataString) {
      this.start_date = dataString[0];
      this.end_date = dataString[1];
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url + this.httpsBasic.clean + "Guard/guardCount";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.query_field,
          start_date: this.start_date,
          end_date: this.end_date,
          project_id: this.project_id,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.id)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(detail) {
      this.hideInUserEdit = true;
      this.editDetail = detail;
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .searchBox {
    display: block;
    > span {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
      a {
        display: inline-block;
        input {
          width: 200px;
        }
      }
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
